// Vite automatically loads environment variables from .env file
// Only variables prefixed with VITE_ are exposed to client code
const env = import.meta.env;

export const SIM_BUILDER_API_END_POINT = env.VITE_SIM_BUILDER_API_URL;
export const ELS_PORTAL_URL = env.VITE_PORTAL_URL;
export const SHORT_DATE_FORMAT = env.VITE_SHORT_DATE_FORMAT;
export const TEXT_DELIMITER = env.VITE_TEXT_DELIMITER;
export const SECRET_KEY_ENCODING_DECODING = env.VITE_SECRET_KEY_FOR_ENCODING_DECODING;
export const SB_URL = env.VITE_SIM_BUILDER_URL;

const DEFAULT_IDLE_WARN_MS = 60000;
const DEFAULT_IDLE_CLOSE_MS = 90000;

const parsedIdleWarn = Number(env.VITE_LIVEAVATAR_IDLE_WARN_MS);
const parsedIdleClose = Number(env.VITE_LIVEAVATAR_IDLE_CLOSE_MS);
const idleWarnValid =
  Number.isFinite(parsedIdleWarn) && parsedIdleWarn > 0;
const idleCloseValid =
  Number.isFinite(parsedIdleClose) && parsedIdleClose > 0;
const idlePairValid =
  idleWarnValid && idleCloseValid && parsedIdleClose > parsedIdleWarn;

/** Soft idle warning before LiveAvatar pause (ms). */
export const LIVEAVATAR_IDLE_WARN_MS = idlePairValid
  ? parsedIdleWarn
  : DEFAULT_IDLE_WARN_MS;
/** Hard idle close — stop LiveAvatar stream (ms). Must be greater than warn. */
export const LIVEAVATAR_IDLE_CLOSE_MS = idlePairValid
  ? parsedIdleClose
  : DEFAULT_IDLE_CLOSE_MS;

const Configs = {
  aws: {
    s3: {
      bucketName: env.VITE_AWS_S3_BUCKET_NAME,
      region: env.VITE_AWS_S3_BUCKET_REGION,
      s3Url: env.VITE_AWS_S3_BUCKET_URL,
      portalBucketName: env.VITE_AWS_S3_PORTAL_BUCKET_NAME,
    },
  },
};

export default Configs;
